// src/components/FamilyCarousel.tsx
import React from "react";
import Banner from "./Banner";
import { ART_ITEMS } from "../../models/banner.model";

const FamilyBanner = (props: { offset: number; isFirstVisit: boolean }) => (
	<Banner
		offset={props.offset}
		isFirstVisit={props.isFirstVisit}
		title="BONK FAMILY"
		items={ART_ITEMS}
	/>
);

export default FamilyBanner;
